<ion-content [fullscreen]="true">

  <ion-grid class="grid-full-screen with-field">

    <ion-row class="ion-align-items-center">
      <ion-col class="ion-align-self-center ion-text-left" size="12">
        <ion-button [routerLink]="['/login']" routerLinkActive="router-link-active" >
          <ion-icon slot="icon-only" name="arrow-back-outline"></ion-icon>
        </ion-button>
      </ion-col>
    </ion-row>

    <ion-row class="logo-row ion-align-items-center">
        <ion-col button (click)="goToHome()" class="ion-align-self-center ion-text-center" size="12" size-sm>
            <img class="logo" src="../../assets/images/logo.png" />
        </ion-col>
    </ion-row>

    <ion-row class="ion-align-items-center">
      <ion-col class="ion-align-self-center ion-text-center" size="12" size-sm>
        <hr>
      </ion-col>
    </ion-row>

    <ion-row class="ion-align-items-center">
      <ion-col class="ion-align-self-center ion-text-center" size="12" size-sm>
        <ion-label class="custom-color">I campi contrassegnati con il simbolo * sono obbligatori</ion-label>
      </ion-col>
    </ion-row>

    <ion-row class="ion-align-items-center">
      <ion-col class="ion-align-self-center ion-text-center" size="12" size-sm>
        <hr>
      </ion-col>
    </ion-row>

    <ion-row class="ion-align-items-center">
      <ion-col class="ion-align-self-center ion-text-center" size="12" size-sm>
          <ion-item color="primary">
              <ion-label position="fixed" i18n>Username * </ion-label>
              <ion-input type="text" name="username" [(ngModel)]="username" (keypress)="register($event.keyCode)"
                  i18n-placeholder placeholder="Scegli un nome utente" autocomplete="off" color="secondary"></ion-input>
          </ion-item>
          <ion-card color="danger" *ngIf="!!validationMessages.username" class="ion-no-margin">
            <ion-card-content class="ion-no-padding">{{ validationMessages.username }}</ion-card-content>
          </ion-card>
      </ion-col>
    </ion-row>

    <ion-row class="ion-align-items-center">
      <ion-col class="ion-align-self-center ion-text-center" size="12" size-sm>
        <hr>
      </ion-col>
    </ion-row>

    <ion-row class="ion-align-items-center">
      <ion-col class="ion-align-self-center ion-text-center" size="12" size-sm>
          <ion-item color="primary">
              <ion-label position="fixed" i18n>Email * </ion-label>
              <ion-input type="email" name="email" [(ngModel)]="email" (keypress)="register($event.keyCode)"
                  i18n-placeholder placeholder="Inserisci la tua email" autocomplete="off" color="secondary"></ion-input>
          </ion-item>
          <ion-card color="danger" *ngIf="!!validationMessages.email" class="ion-no-margin">
            <ion-card-content class="ion-no-padding">{{ validationMessages.email }}</ion-card-content>
          </ion-card>
      </ion-col>
    </ion-row>

    <ion-row class="ion-align-items-center">
      <ion-col class="ion-align-self-center ion-text-center" size="12" size-sm>
          <ion-item color="primary">
              <ion-label position="fixed" i18n>Ripeti Email * </ion-label>
              <ion-input type="email" name="emailCheck" [(ngModel)]="emailCheck" (keypress)="register($event.keyCode)"
                  i18n-placeholder placeholder="Inserisci di nuovo l'email" autocomplete="off" color="secondary"></ion-input>
          </ion-item>
          <ion-card color="danger" *ngIf="!!validationMessages.emailCheck" class="ion-no-margin">
            <ion-card-content class="ion-no-padding">{{ validationMessages.emailCheck }}</ion-card-content>
          </ion-card>
      </ion-col>
    </ion-row>

    <ion-row class="ion-align-items-center">
      <ion-col class="ion-align-self-center ion-text-center" size="12" size-sm>
        <hr>
      </ion-col>
    </ion-row>

    <ion-row class="ion-align-items-center">
      <ion-col class="ion-align-self-center ion-text-center" size="12" size-sm>
          <ion-item color="primary">
              <ion-label position="fixed" i18n>Password *</ion-label>
              <ion-input type="password" name="password" [(ngModel)]="password" (keypress)="register($event.keyCode)"
                  i18n-placeholder placeholder="Inserisci la password" autocomplete="off" color="secondary"></ion-input>
          </ion-item>
          <ion-card color="danger" *ngIf="!!validationMessages.password" class="ion-no-margin">
            <ion-card-content class="ion-no-padding">{{ validationMessages.password }}</ion-card-content>
          </ion-card>
      </ion-col>
    </ion-row>

    <ion-row class="ion-align-items-center">
      <ion-col class="ion-align-self-center ion-text-center" size="12" size-sm>
          <ion-item color="primary">
              <ion-label position="fixed" i18n>Ripeti password *</ion-label>
              <ion-input type="password" name="passwordCheck" [(ngModel)]="passwordCheck" (keypress)="register($event.keyCode)"
                  i18n-placeholder placeholder="Inserisci di nuovo la password" autocomplete="off" color="secondary"></ion-input>
          </ion-item>
          <ion-card color="danger" *ngIf="!!validationMessages.passwordCheck" class="ion-no-margin">
            <ion-card-content class="ion-no-padding">{{ validationMessages.passwordCheck }}</ion-card-content>
          </ion-card>
      </ion-col>
    </ion-row>

    <ion-row class="ion-align-items-center">
      <ion-col class="ion-align-self-center ion-text-center" size="12" size-sm>
        <hr>
      </ion-col>
    </ion-row>

    <ion-row class="ion-align-items-center">
      <ion-col class="ion-align-self-center ion-text-center" size="12" size-sm>
        <ion-item color="primary">
          <ion-label class="ion-text-wrap">
            Acconsento alla registrazione ed al trattamento dei dati inseriti *
            <ion-button (click)="openPrivacyPolicyUrl()" class="ion-no-margin">
              <ion-icon slot="start" name="help-circle-outline"></ion-icon> Clicca quì per approfondire
            </ion-button>
          </ion-label>
          <ion-checkbox slot="end" [(ngModel)]="privacyPolicyAccepted" color="primary"></ion-checkbox>
        </ion-item>
        <ion-card color="danger" *ngIf="!!validationMessages.privacyPolicyAccepted" class="ion-no-margin">
          <ion-card-content class="ion-no-padding">{{ validationMessages.privacyPolicyAccepted }}</ion-card-content>
        </ion-card>
      </ion-col>
    </ion-row>

    <ion-row class="ion-align-items-center">
      <ion-col class="ion-align-self-center ion-text-center" size="12" size-sm>
        <ion-item color="primary">
          <ion-label class="ion-text-wrap">
            Acconsento all'uso del mio identificativo pubblicitario
            <ion-button (click)="openPrivacyPolicyUrl()" class="ion-no-margin">
              <ion-icon slot="start" name="help-circle-outline"></ion-icon> Clicca quì per approfondire
            </ion-button>
          </ion-label>
          <ion-checkbox slot="end" [(ngModel)]="personalizedAdAccepted" color="primary"></ion-checkbox>
        </ion-item>
      </ion-col>
    </ion-row>

    <ion-row class="ion-align-items-center">
      <ion-col class="ion-align-self-center ion-text-center" size="12" size-sm>
        <hr>
      </ion-col>
    </ion-row>

    <ion-row class="ion-align-items-center">
      <ion-col class="ion-align-self-center ion-text-center" size="12" size-sm>
          <ion-nav-link (click)="openTermsAndConditionsUrl()">
              <ion-label class="custom-color" color="secondary" i18n>Termini e condizioni</ion-label>
          </ion-nav-link>
      </ion-col>
    </ion-row>

    <ion-row class="ion-align-items-center">
        <ion-col class="ion-align-self-center ion-text-center" size="12" size-sm>
            <ion-nav-link (click)="openPrivacyPolicyUrl()" >
                <ion-label class="custom-color" color="secondary" i18n>Politica sulla privacy</ion-label>
            </ion-nav-link>
        </ion-col>
    </ion-row>

    <ion-row class="ion-align-items-center">
      <ion-col class="ion-align-self-center ion-text-center" size="12" size-sm>
        <hr>
      </ion-col>
    </ion-row>

    <ion-row class="ion-align-items-center">
      <ion-col class="ion-align-self-center ion-text-center" size="12" size-sm>
          <ion-button color="primary" expand="full" (click)="register()" i18n>Registrati</ion-button>
      </ion-col>
    </ion-row>

    <div class="spacer-150"></div>

  </ion-grid>

</ion-content>